import { render, staticRenderFns } from "./BenefitVoucherList.vue?vue&type=template&id=48d6a06a"
import script from "./BenefitVoucherList.vue?vue&type=script&lang=js"
export * from "./BenefitVoucherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports